export const selectAllOption = { id: 'all', label: 'Select all', value: 'all' };
